import styled from 'styled-components'

export const RaffleCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 276px;
  border: 1px solid var(--gray200);
  border-radius: 8px;

  h3,
  p {
    margin-top: 8px;
  }
`

export const TagContent = styled.div`
  > div > span {
    display: flex;
    margin: 0;
    margin-left: 12px;
  }
`

export const RaffleCardContent = styled.div`
  padding: 12px;
`

export const ExtraChanceTag = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 2;
  span {
    margin: 0;
    padding: 0px 2px;
  }
`

export const RaffleCardGift = styled.div<{
  $bgColorCard: string
  $giftColor: boolean
}>`
  position: relative;
  border-radius: 8px;
  margin-bottom: 16px;
  margin: 12px;
  background-color: ${({ $bgColorCard }) => $bgColorCard};
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    ${({ $giftColor }) => $giftColor && `filter: grayscale(1);`}
  }
`
